import { BehaviorSubject, Observable } from 'rxjs';
import { Client, ClientFilter } from './client';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';

import { ClientService } from '../services/client.service';
import { of } from 'rxjs';

export class ClientDataSource implements DataSource<Client> {

    private protocolsSubject = new BehaviorSubject<Client[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public loading$ = this.loadingSubject.asObservable();
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public totalItems$ = this.totalSubject.asObservable();

    constructor(private service: ClientService) { }

    connect(_collectionViewer: CollectionViewer): Observable<Client[]> {
        return this.protocolsSubject.asObservable();
    }

    disconnect(_collectionViewer: CollectionViewer): void {
        this.protocolsSubject.complete();
        this.loadingSubject.complete();
        this.totalSubject.complete();
    }

    loadClient(filter = new ClientFilter()): void {

        this.loadingSubject.next(true);

        this.service.filter(filter).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe(data => {
            if (data && data.content) {
                this.protocolsSubject.next(data.content as Client[]);
                this.totalSubject.next(data.totalElements as number);
            } else if (data) {
                this.protocolsSubject.next(data as Client[]);
                this.totalSubject.next(data.length as number);
            } else {
                this.protocolsSubject.next([]);
                this.totalSubject.next(0);
            }
        });
    }

}
